import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { LearningDevelopmentResponse } from '@app/shared/interfaces/learning-development.model';
import { GlobalErrorService } from '@app/shared/services/global-error.service';
import { LEARNING_DEVELOPMENT } from '@app/shared/constants/learning-development.constants';
import { formatQuarter, getCurrentQuarter } from '@app/shared/utils/utils';

@Injectable({
  providedIn: 'root',
})
export class LearningDevelopmentService {
  private baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorService,
  ) {}

  getLearningDevelopmentData(
    vendorId: string,
    employeeId: string,
    quarter: string | number,
    year: number
  ): Observable<LearningDevelopmentResponse> {
    const formattedQuarter = formatQuarter(quarter);
    let params = new HttpParams()
      .set(LEARNING_DEVELOPMENT.API.PARAM_VENDOR_ID, vendorId)
      .set(LEARNING_DEVELOPMENT.API.PARAM_QUARTER, formattedQuarter)
      .set(LEARNING_DEVELOPMENT.API.PARAM_YEAR, year.toString());

    if (employeeId !== '') {
      params = params.set(LEARNING_DEVELOPMENT.API.PARAM_EMPLOYEE_ID, employeeId);
    }
    
    return this.http
      .get<LearningDevelopmentResponse>(
        `${this.baseUrl}${LEARNING_DEVELOPMENT.API.ENDPOINT}`, 
        { params }
      )
      .pipe(
        catchError((error) => this.errorHandler.logError(error))
      );
  }
}
